/** Remote-ready ad frequency config. Fetch can call setInterstitialEveryN later. */

const DEFAULT_INTERSTITIAL_EVERY_N = 5;

let interstitialEveryN = DEFAULT_INTERSTITIAL_EVERY_N;

export function getInterstitialEveryN() {
    return interstitialEveryN;
}

export function setInterstitialEveryN(n) {
    const parsed = Number(n);
    if (!Number.isFinite(parsed) || parsed < 1) return;
    interstitialEveryN = Math.floor(parsed);
}
